import React from 'react';
import {
  AccordionTheme,
  TextButton,
  TextButtonPriority,
  useTPAComponentsContext,
} from 'wix-ui-tpa/cssVars';
import { st, classes } from '../../Widget.st.css';
import { ISettingsContextValue } from '@wix/tpa-settings';
import settingsParams, { LayoutType } from '../../../settingsParams';
import { useSettings } from '@wix/tpa-settings/react';
import { DATA_HOOKS } from '../../../../../constants/dataHooksElements';
import { TabItem } from 'wix-ui-tpa';

export interface VerticalCategoriesProps {
  categoriesToRender: TabItem[];
  activeTab: number;
  sideCategoriesPosition: boolean;
  setActiveTab: (index: number) => void;
}

const VerticalCategories = ({
  categoriesToRender,
  activeTab,
  sideCategoriesPosition,
  setActiveTab,
}: VerticalCategoriesProps) => {
  const { seo } = useTPAComponentsContext();
  const settings: ISettingsContextValue = useSettings();
  const itemAppearance = settings.get(settingsParams.itemAppearance);
  const layout: LayoutType = settings.get(settingsParams.layout);
  const numberLayout = layout === LayoutType.Stripes;
  const theme = numberLayout ? AccordionTheme.Box : itemAppearance;

  return (
    <div
      className={st(classes.Tabs, {
        isSideCategoriesPosition: sideCategoriesPosition,
        theme,
      })}
      data-hook={DATA_HOOKS.WIDGET_CATEGORIES_VERTICAL}
    >
      {categoriesToRender.map((category, index) => {
        return (
          <TextButton
            as={seo ? 'a' : 'button'}
            key={`category-button-${index}`}
            priority={
              activeTab === index
                ? TextButtonPriority.link
                : TextButtonPriority.secondary
            }
            className={st(classes.underlineTextColor, {
              isLink: activeTab === index,
            })}
            onClick={setActiveTab.bind(null, index)}
            data-hook={DATA_HOOKS.WIDGET_CATEGORIES_VERTICAL_ITEM(index)}
            href={seo ? category.href : undefined}
          >
            {category.title}
          </TextButton>
        );
      })}
    </div>
  );
};

export default VerticalCategories;
